import React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';

// Fullscreen, pinch-to-zoom image viewer with swipe / arrow navigation between a
// product's photos. Used on the product detail page, the popped-up ad modal
// (ColonyDetailModal) and the home-page ad modal — NOT on the grid cards.
// For multi-photo products a "1 / N" counter is shown so shoppers know they can
// swipe (touch) or drag / use the arrows to browse the rest.
export const ImageLightbox = ({ images = [], open, index = 0, onClose }) => {
  const slides = (images || []).filter(Boolean).map((src) => ({ src }));
  if (!slides.length) return null;
  const hasMany = slides.length > 1;
  const safeIndex = Math.min(Math.max(index, 0), slides.length - 1);
  return (
    <Lightbox
      open={open}
      close={onClose}
      index={safeIndex}
      slides={slides}
      plugins={hasMany ? [Zoom, Counter] : [Zoom]}
      controller={{ closeOnBackdropClick: true }}
      zoom={{ maxZoomPixelRatio: 4, scrollToZoom: true, doubleTapDelay: 250 }}
      carousel={{ finite: !hasMany }}
      counter={{ container: { style: { top: 'unset', bottom: 12, left: 16, fontSize: 14 } } }}
      styles={{ container: { backgroundColor: 'rgba(0,0,0,0.92)' } }}
      render={
        hasMany ? {} : { buttonPrev: () => null, buttonNext: () => null }
      }
    />
  );
};

export default ImageLightbox;
